window.addEventListener('load', () => {
    const target = document.querySelector('.preference');
    const options = { rootMargin: '0px', threshold: 0.01 };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !m.widgets.isLoaded()) {
                m.widgets.load();
            }
        })
    }, options);

    observer.observe(target);
});

document.addEventListener('DOMContentLoaded', function () {
    const DESKTOP_SCREEN = 1192;
    const tabs = $('.js-assets-tabs');
    const list = $('.js-assets-list');
    const content = $('.js-assets-content');
    const tradeList = $('.js-trading-list').children();

    const initAssetsSlider = () => {
        content.slick({
            slidesToShow: 1,
            arrows: false,
            dots: false,
            draggable: false,
            swipe: false,
            fade: true,
            asNavFor: '.js-assets-tabs',
            rtl: m.about.rtl,
        });

        tabs.slick({
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.js-assets-content',
            dots: false,
            arrows: false,
            centerMode: true,
            variableWidth: true,
            focusOnSelect: true,
            rtl: m.about.rtl,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        vertical: true,
                        centerMode: false,
                        slidesToShow: 8,
                        variableWidth: false,
                        draggable: false,
                        swipe: false,
                    }
                }
            ]
        });

        // assets list sliders [node list]
        const initListSliders = (list) => {
            list.each(function () {
                if ($(window).width() >= DESKTOP_SCREEN) {
                    if ($(this).hasClass('slick-initialized')) {
                        $(this).slick('unslick');
                    }
                    return false;
                }
                if (!$(this).hasClass('slick-initialized')) {
                    return $(this).slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        initialSlide: 1,
                        slidesToShow: 1,
                        centerMode: true,
                        variableWidth: true,
                        rtl: m.about.rtl,
                    });
                }
            });
        };

        $(window).on('load resize orientationchange', () => {
            list.length && initListSliders(list);
        });

        // trading list switching
        for (let item of tradeList) {
            item.addEventListener('click', () => {
                let tabIndex = +item.dataset.assetTab;

                if (!tabIndex) return;
                tabs.slick('slickGoTo', tabIndex);
            });
        }
    };


    (tabs && content) && initAssetsSlider();
});
